export default __webpack_public_path__ + "static/media/020-canyon.42fc94dd.svg";